var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconplaceholders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45986 12.6757C7.84671 12.4339 7.84671 11.5661 8.45986 11.3243C9.77027 10.8075 10.8076 9.77021 11.3243 8.4598C11.5661 7.84668 12.4339 7.84676 12.6757 8.45987C13.1925 9.77016 14.2298 10.8075 15.5401 11.3243C16.1533 11.5661 16.1533 12.4339 15.5401 12.6757C14.2298 13.1925 13.1925 14.2298 12.6757 15.5401C12.4339 16.1532 11.5661 16.1533 11.3243 15.5402C10.8076 14.2298 9.77027 13.1925 8.45986 12.6757Z",
    fill: "#3B5118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 18V6C2.5 4.34315 3.84315 3 5.5 3H6.75C7.16421 3 7.5 3.33579 7.5 3.75V4.25C7.5 4.66421 7.16421 5 6.75 5H5.5C4.94772 5 4.5 5.44772 4.5 6V18C4.5 18.5523 4.94772 19 5.5 19H6.75C7.16421 19 7.5 19.3358 7.5 19.75V20.25C7.5 20.6642 7.16421 21 6.75 21H5.5C3.84315 21 2.5 19.6569 2.5 18Z",
    fill: "#3B5118"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18V6C21.5 4.34315 20.1569 3 18.5 3H17.25C16.8358 3 16.5 3.33579 16.5 3.75V4.25C16.5 4.66421 16.8358 5 17.25 5H18.5C19.0523 5 19.5 5.44772 19.5 6V18C19.5 18.5523 19.0523 19 18.5 19H17.25C16.8358 19 16.5 19.3358 16.5 19.75V20.25C16.5 20.6642 16.8358 21 17.25 21H18.5C20.1569 21 21.5 19.6569 21.5 18Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconplaceholders);
export default __webpack_public_path__ + "static/media/icon.placeholders.fd5d98b45babdb34cd44442e6553163b.svg";
export { ForwardRef as ReactComponent };